module.exports = __webpack_public_path__ + "img/ico-history-off-copy.380dd710.svg";